import { render, staticRenderFns } from "./UltimosPagosPorDia.vue?vue&type=template&id=dc990078&"
import script from "./UltimosPagosPorDia.vue?vue&type=script&lang=js&"
export * from "./UltimosPagosPorDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports